import { SUBSCRIPTION_ID_ATTRIBUTE } from "./constants";
import { getSubscription } from "./helpers";

const SUBSCRIPTION_DETAIL_PAGE_REGEX =
  /\/subscriptions\/(?<subscriptionId>\d+)/;

async function checkIfInCustomizationWindow(subscriptionId) {
  const currentESTDateTime = new Date().toLocaleString("en-US", {
    timeZone: "America/New_York",
  });
  let nextOrderDate = new Date(currentESTDateTime);

  const subscription = await getSubscription(subscriptionId);

  if (!subscription) return false;

  // for annual subscriptions, set nextOrderDate to first of next month,
  // otherwise use next_charge_scheduled_at (to accurately reflect skipped months)
  if (subscription.is_prepaid) {
    nextOrderDate.setMonth(nextOrderDate.getMonth() + 1, 1);
  } else {
    nextOrderDate = new Date(
      subscription.next_charge_scheduled_at,
    ).toLocaleString("en-US", {
      timeZone: "America/New_York",
    });
  }

  // customization window start one month prior
  const windowStart = new Date(nextOrderDate);
  windowStart.setMonth(windowStart.getMonth() - 1);
  windowStart.setDate(3);
  windowStart.setHours(0, 0, 0, 0);

  const currentDate = new Date(currentESTDateTime);

  return currentDate >= windowStart;
}

export async function maybeLoadAddOnsExtension({ slot, template, pathname }) {
  const subscriptionMatch = pathname.match(SUBSCRIPTION_DETAIL_PAGE_REGEX);
  if (!subscriptionMatch) return;

  slot.setAttribute("hidden", "");

  const clone = template.content.cloneNode(true);

  const subscriptionId = subscriptionMatch.groups.subscriptionId;
  const isInCustomizationWindow = await checkIfInCustomizationWindow(
    Number(subscriptionId),
  );
  const emptyMessageSection = clone.querySelector("[data-addons-empty]");

  if (!isInCustomizationWindow) {
    clone.replaceChildren(emptyMessageSection);
  } else {
    emptyMessageSection.style.display = "none";
    const vbcCustomEls = [
      ...clone.querySelectorAll(":is(vbc-selection, vbc-addons)"),
    ];
    for (const customEl of vbcCustomEls) {
      customEl.setAttribute(SUBSCRIPTION_ID_ATTRIBUTE, subscriptionId);
    }
  }

  slot.appendChild(clone);

  slot.removeAttribute("hidden");
}
